<template>
  <div class="noCarParking">
    <topNav :title="title"></topNav>
    <section class="list list_parkings">
      <ul v-show="parkingList && parkingList.length">
        <li class="parking_item" v-for="(item, index) in parkingList" :key="index" @click="getParking(item)">
          <div class="parkingname">{{ item.parkingname }}</div>
        </li>
      </ul>
      <div class="empty_container" v-show="!parkingList.length && !loadingParking">
        <div class="cont">
          <div class="icon icon_noinvoice"></div>
          <p class="tips">暂无停车场</p>
        </div>
      </div>

      <div class="loadmore" v-if="loadingParking"><van-loading type="spinner" /></div>
    </section>
  </div>
</template>
<script>
import topNav from "../topnav/topnav"
import { DETAIL as API } from "@/assets/api"

export default {
  name: 'noCarParking',
  components: {
    topNav,
  },
  data() {
    return {
      title: "选择停车场",
      loadingParking: false,
      parkingList: [],
      data: ''
    }
  },
  computed: {

  },
  methods: {
    getParks() {
      this.loadingParking = true
      let req = {
        data: this.data,
        phonenumber: this.$store.state.phonenumber,
        openid: sessionStorage.getItem("originalId")
      }
      this.$http({
        method: 'post',
        url: API.GET_PARKING_LIST,
        data: req,
        success: function (res) {
          if (res.code == 500) {
            this.Toast(res.msg)
            this.loadingParking = false
            return
          }
          if (res.data && res.data.length > 0) {
            this.parkingList = res.data
          }
          this.loadingParking = false
        }.bind(this),
        error: function (error) {
          this.loadingParking = false
        }
      })
    },
    getParking(item) {
      var query = {
        commid: item.commid,
        parkingno: item.parkingno,
      }
      this.$router.push({ name: 'noCarApply', query: query })
    },
  },
  created() {
    this.data = this.$route.query.commname
    this.getParks()
  },
}
</script>
<style lang="less" scoped>
.noCarParking {
  min-height: 100vh;
  border-bottom: 1px solid #fff;
  background-color: #fff;
  box-sizing: border-box;
}

.parkingname {
  font-size: 17px;
  line-height: 32px;
  text-align: center;
}


.list_parkings {
  .parking_item {
    position: relative;
    height: 210px/2;
    width: 705px/2;
    margin: 10px auto;
    background: url('../../../static/images/bg_parkingname.png') center no-repeat;
    background-size: 100%;

    .parkingname {
      width: 100%;
      font-size: 20px;
      letter-spacing: 2px;
      color: #ffffff;
      font-family: AlibabaPuHuiTi-Regular;
      line-height: 90px;
    }
  }

  .emptyTip {
    font-size: 16px;
    text-align: center;
    line-height: 60px;
  }
}

.empty_container {
  margin-top: 80px;

  .cont {
    margin-bottom: 30px;

    .icon_noinvoice {
      width: 161px;
      height: 127px;
      margin: 0 auto;
      background: url('../../../static/images/icon_noinvoice.png') center no-repeat;
      background-size: 100% auto;
    }

    .tips {
      text-align: center;
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/noCarParking.vue